import React, { FC, ReactElement } from 'react';
import styles from './cardWithStickyHeader.module.scss';
import { Card } from 'antd';
import { ReactComponent as BackIcon } from 'assets/icons/back_arrow.svg';
import COButton from '../COButton';
import { ButtonType } from 'enums/ButtonEnums';
import clsx from 'clsx';
import LoaderAnimation from '../LoaderAnimation';
import { useParams } from 'react-router-dom';
import isProductDisabled from 'shared/utils/isProductDisabled';

export interface ButtonProps {
  type:
    | ButtonType.DEFAULT
    | ButtonType.PRIMARY
    | ButtonType.LINK
    | ButtonType.TEXT;
  title: string;
  icon?: React.JSX.Element;
  isAdd?: boolean;
  clickCallback?: () => void;
  loading?: boolean;
  submit?: boolean;
}

interface CardWithStickyHeaderProps {
  title: string;
  backCallback?: () => void;
  actionButtons?: ButtonProps[];
  children: ReactElement;
  loading?: boolean;
  subHeading?: string;
}

const CardWithStickyHeader: FC<CardWithStickyHeaderProps> = props => {
  const { status } = useParams();
  const { title, backCallback, actionButtons, children, loading, subHeading } =
    props;
  const isDisabled = isProductDisabled(status);

  return (
    <div className={styles.cardContainer}>
      {loading ? (
        <div className={styles.loaderAnimation}>
          <LoaderAnimation />
        </div>
      ) : (
        <Card className={styles.cardWrapper}>
          <div className={styles.headerContainer}>
            <div className={styles.headingContainer}>
              <div className={styles.backIconContainer}>
                <BackIcon onClick={backCallback} className={styles.backIcon} />
              </div>
              <div>
                <div className={styles.title}>{title}</div>
                {subHeading && (
                  <div className={styles.subHeading}>{subHeading}</div>
                )}
              </div>
            </div>
            <div className={styles.actionContainer}>
              {actionButtons?.map(button => {
                const {
                  isAdd,
                  title,
                  icon,
                  clickCallback,
                  type: buttonType,
                  loading = false,
                  submit,
                } = button;
                return (
                  <div key={title}>
                    <div
                      className={clsx(styles.addAction, {
                        [styles.hideAction]:
                          isDisabled && buttonType !== ButtonType.PRIMARY,
                      })}>
                      <COButton
                        onClick={clickCallback}
                        submit={submit}
                        loading={loading}
                        type={buttonType}
                        {...(buttonType === ButtonType.TEXT && { text: true })}>
                        {isAdd && icon}
                        <div
                          className={clsx(
                            buttonType === ButtonType.TEXT && styles.buttonTitle
                          )}>
                          {title}
                        </div>
                        {!isAdd && icon}
                      </COButton>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.childrenContainer}>{children}</div>
        </Card>
      )}
    </div>
  );
};

export default CardWithStickyHeader;
